/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import {
	MediaUpload,
	MediaUploadCheck,
} from '@wordpress/block-editor';
import {
	SelectControl,
	BaseControl,
	Button,
} from '@wordpress/components';
import { addFilter } from '@wordpress/hooks';

/**
 * External dependencies
 */

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import IconPicker from '../../../components/icon-picker';

const ALLOWED_MEDIA_TYPES = [ 'image' ];

const hookPrefix = 'gutenify-block-icon';

addFilter(
	`${ hookPrefix }-options-tab-content`,
	'Gutenify/Block/Icon/InspectorControls/BasicControls/tabs/content',
	( content, { attributes, setAttributes } ) => {
		const { source, iconName, iconImage } = attributes;

		const onRemoveImage = () => {
			setAttributes( { iconImage: '' } );
		};

		return [
			...content,
			<Fragment key="gutenify-block-icon-inspector-controls-basic-controls-tab">
				<Accordion tabs={ [
					{
						name: 'icon',
						initialOpen: true,
						label: () => {
							return __( 'Icon' );
						},
						cb: () => {
							return <>
								<SelectControl
									label={ __( 'Select Source' ) }
									value={ source }
									onChange={ ( val ) => {
										setAttributes( { source: val } );
									} }
									options={ [
										{ value: 'icon', label: __( 'Icon' ) },
										{ value: 'image', label: __( 'Image' ) },
									] }
								/>
								{ 'icon' === source && (
									<Fragment>
										<IconPicker
											value={ iconName }
											onChange={ ( val ) => {
												setAttributes( { iconName: val } );
											} }

										/>
									</Fragment>
								) }
								{ 'image' === source && (
									<Fragment>
										<BaseControl
											className="editor-bg-image-control"
											label={ __( '' ) }
											id="image-upload"
										>
											<MediaUploadCheck>
												<MediaUpload
													onSelect={ ( media ) => {
														if ( ! media || ! media.url ) {
															setAttributes( { iconImage: null } );
															return;
														}

														if ( ! media.type || 'image' !== media.type ) {
															setAttributes( { iconImage: null } );
															return;
														}
														// if ( media.sizes ) {
														// 	const newImg = this.getImageSize( media.sizes );
														// 	imageSizeOptions = newImg;
														// }
														setAttributes( { iconImage: media } );
													} }
													allowedTypes={ ALLOWED_MEDIA_TYPES }
													value={ iconImage }
													render={ ( { open } ) => (
														<Button onClick={ open } isSecondary>
															{ __( 'Open Media Library' ) }
														</Button>
													) }
												/>
											</MediaUploadCheck>

											{ iconImage && iconImage.url !== 'null' && iconImage.url !== '' && (
												<>
													<br />
													<Button onClick={ onRemoveImage } isLink isDestructive>
														{ __( 'Remove Image' ) }
													</Button>
												</>
											) }
										</BaseControl>
									</Fragment>
								) }
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);
